module.exports = __webpack_public_path__ + "r-v3/img/music_selected.97e1d8b1.svg";